import React from 'react';
import { Alert } from 'antd';
import { FormattedMessage } from 'react-intl';

const SubscriptionWarning = () => (
	<Alert message={<FormattedMessage id="subscription_error_warning" />} type="error" showIcon />
);

export default SubscriptionWarning;
